/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
moment.locale('ja')
import { Octokit } from "@octokit/core";
import { Endpoints } from "@octokit/types";

export interface ProjectState {
  Clietns: Array<types.ClientParam>
  githubusername: string | null
  orgs:Endpoints["GET /users/{username}/orgs"]["response"]["data"]
  [key: string]: any;
}

const Project = defineModule({
  state: (): ProjectState => {
    return {
      Clietns: [],
      githubusername: null,
      orgs:[],
    }
  },
  getters: {
    emptyClient: (...args): types.ClientParam => {
      return {
        clientId: null,
        tenantId: '',
        name: '',
        nameKana: '',
        isActive: true
      }
    },
    emptyProject: (...args): types.ProjectParamWithLocalDate => {
      return {
        projectId: null,
        clientId: '',
        tenantId: '',
        name: '',
        nameKana: '',
        isActive: true,
        startDate: null,
        endDate: null,
        startDateDisp: null,
        startDateLocal: null,
        endDateDisp: null,
        endDateLocal: null,
        startDateMenu:false,
        endDateMenu: false,
        branchId: null,
        code: '',
        projectRepositoriesJSON: '',
        projectRepositories: [],
        workOrderNumbersJSON: '',
        defaultWorkOrderNumberId: null,
        workOrderNumbers: []
      }
    },
    emptyBranch: (...args): types.BranchParam => {
      return {
        branchId: null,
        tenantId: '',
        name: ''
      }
    }
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    }
  },
  actions: {
    async addClient(context, payload: types.ClientParam): Promise<boolean> {
      const { rootState } = moduleActionContext(context, Project)
      var param = Object.assign({}, payload) as unknown as { [key: string]: string; }
      param.clientId = param.clientId == null ? '' : param.clientId
      if (payload.clientId == '' || payload.clientId == null) {
        const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/project/addclient', "クライアントの追加に失敗しました。", param, rootState.Login.accessToken)
        var groups = retval.data.data
        return groups
      } else {
        const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/project/updateclient', "クライアントの設定に失敗しました。", param, rootState.Login.accessToken)
        groups = retval.data.data
        return groups  
      }
    },
    async listAllClients(context): Promise<Array<types.ClientParam>> {
      const { rootState, commit } = moduleActionContext(context, Project)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<Array<types.ClientParam>>>('/api/project/listclientall', "クライアントの取得に失敗しました", {}, rootState.Login.accessToken)
      var list = retval.data.data
      commit.SET_VALUE({name: 'Clietns', value: list})
      return list
    },
    defaultClient(context) : types.ClientParam {
      const { rootState } = moduleActionContext(context, Project)
      return {
        clientId: '',
        tenantId: rootState.Login.userInfo.tenantId,
        name: '',
        nameKana: '',
        isActive: true
      }
    },
    async addBranch(context, payload: types.BranchParam): Promise<boolean> {
      const { rootState } = moduleActionContext(context, Project)
      let param = Object.assign({}, payload) as unknown as {[key: string]: string;}
      if (payload.branchId == '' || payload.branchId == null) {
        const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/project/addbranch', "ブランチの追加に失敗しました。", param, rootState.Login.accessToken)
        var groups = retval.data.data
        return groups
      } else {
        const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/project/updatebranch', "ブランチの設定に失敗しました。", param, rootState.Login.accessToken)
        groups = retval.data.data
        return groups  
      }
    },
    async listAllBranches(context): Promise<Array<types.BranchParam>> {
      const { rootState, commit } = moduleActionContext(context, Project)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<Array<types.BranchParam>>>('/api/project/listbranchall', "ブランチの取得に失敗しました", {}, rootState.Login.accessToken)
      var list = retval.data.data
      commit.SET_VALUE({name: 'Clietns', value: list})
      return list
    },
    defaultBranch(context) : types.BranchParam {
      const { rootState } = moduleActionContext(context, Project)
      return {
        branchId: null,
        tenantId: rootState.Login.userInfo.tenantId,
        name: ''
      }
    },
    async add(context, payload: types.ProjectParamWithLocalDate): Promise<boolean> {
      const { rootState, dispatch } = moduleActionContext(context, Project)
      var toSubmit = await dispatch.convertProjectFromLocal(payload)
      let param = Object.assign({}, toSubmit) as unknown as { [key: string]: string; }
      param.startDate = toSubmit.startDate == null ? '' : toSubmit.startDate
      param.endDate = toSubmit.endDate == null ? '' : toSubmit.endDate
      if (toSubmit.projectId == '' || toSubmit.projectId == null) {
        const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/project/add', "プロジェクトの追加に失敗しました。", param, rootState.Login.accessToken)
        var groups = retval.data.data
        return groups
      } else {
        const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/project/update', "プロジェクトの設定に失敗しました。", param, rootState.Login.accessToken)
        groups = retval.data.data
        return groups  
      }
    },
    async addWorkOrderNumber(context, payload: { projectId: string; name: string }): Promise<boolean> {
      const { rootState } = moduleActionContext(context, Project)
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>(
        `/api/project/addworkordernumber/${payload.projectId}`,
        "作番の追加に失敗しました。",
        { name: payload.name },
        rootState.Login.accessToken
      )
      return retval.data.data
    },
    async updateWorkOrderNumber(context, payload: { workOrderNumberId: string; name: string }): Promise<boolean> {
      const { rootState } = moduleActionContext(context, Project)
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>(
        '/api/project/updateworkordernumber',
        "作番の更新に失敗しました。",
        { workOrderNumberId: payload.workOrderNumberId, name: payload.name },
        rootState.Login.accessToken
      )
      return retval.data.data
    },
    async deleteWorkOrderNumber(context, workOrderNumberId: string): Promise<boolean> {
      const { rootState } = moduleActionContext(context, Project)
      const retval = await Lib.Ajax.deleteHandleError<types.DataResponse<boolean>>(
        `/api/project/deleteworkordernumber/${workOrderNumberId}`,
        "作番の削除に失敗しました。",
        {},
        rootState.Login.accessToken
      )
      return retval.data.data
    },
    async previewBulkAssignWorkOrder(context, payload: { projectId: string; fiscalYear: number; workOrderNumberId: string }): Promise<any> {
      const { rootState } = moduleActionContext(context, Project)
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<any>>(
        '/api/project/previewbulkassignworkorder',
        "一括適用プレビューに失敗しました。",
        { projectId: payload.projectId, fiscalYear: String(payload.fiscalYear), workOrderNumberId: payload.workOrderNumberId },
        rootState.Login.accessToken
      )
      return retval.data.data
    },
    async bulkAssignWorkOrder(context, payload: { projectId: string; fiscalYear: number; workOrderNumberId: string }): Promise<any> {
      const { rootState } = moduleActionContext(context, Project)
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<any>>(
        '/api/project/bulkassignworkorder',
        "一括適用に失敗しました。",
        { projectId: payload.projectId, fiscalYear: String(payload.fiscalYear), workOrderNumberId: payload.workOrderNumberId },
        rootState.Login.accessToken
      )
      return retval.data.data
    },
    async setDefaultWorkOrderNumber(context, payload: { project: types.ProjectParamWithLocalDate; workOrderNumberId: string | null }): Promise<boolean> {
      const { dispatch } = moduleActionContext(context, Project)
      var updated = Object.assign({}, payload.project)
      updated.defaultWorkOrderNumberId = payload.workOrderNumberId
      return await dispatch.add(updated)
    },
    async listAll(context): Promise<Array<types.ProjectParamWithLocalDate>> {
      const { rootState, commit, dispatch } = moduleActionContext(context, Project)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<Array<types.ProjectParam>>>('/api/project/listall', "プロジェクトの取得に失敗しました", {}, rootState.Login.accessToken)
      var list = await dispatch.convertProjectToLocal(retval.data.data)
      commit.SET_VALUE({name: 'Projects', value: list})
      return list
    },
    defaultProject(context) : types.ProjectParamWithLocalDate {
      const { rootState } = moduleActionContext(context, Project)
      return {
        projectId: null,
        clientId: '',
        tenantId: rootState.Login.userInfo.tenantId,
        name: '',
        nameKana: '',
        isActive: true,
        startDate: null,
        endDate: null,
        startDateDisp: null,
        startDateLocal: null,
        endDateDisp: null,
        endDateLocal: null,
        startDateMenu:false,
        endDateMenu: false,
        branchId: null,
        code: '',
        projectRepositoriesJSON: '',
        projectRepositories:[],
        workOrderNumbersJSON: '',
        defaultWorkOrderNumberId: null,
        workOrderNumbers: []
      }
    },
    defaultProjectRepositories(context, project:types.ProjectParamWithLocalDate):types.ProjectRepositoryParam {
      return {
        projectRepositoryId: null,
        projectId: project.projectId,
        organzationName: '',
        repositoryName: '',
        organizationId: 0,
        repositoryId: 0,
        url: ''
      }
    },
    convertProjectToLocal(context,projects:Array<types.ProjectParam>): Array<types.ProjectParamWithLocalDate> {
      const { rootState } = moduleActionContext(context, Project)
      return projects.map(p => {
        return {
          projectId: p.projectId,
          clientId: p.clientId,
          tenantId: p.tenantId,
          name: p.name,
          nameKana: p.nameKana,
          isActive: p.isActive,
          startDate: p.startDate,
          endDate: p.endDate,
          startDateDisp: p.startDate == null ? null : moment.tz(p.startDate, moment.tz.guess()).format('YYYY-MM-DD'),
          startDateLocal: p.startDate == null ? null : moment.tz(p.startDate, moment.tz.guess()).format('YYYY-MM-DD'),
          endDateDisp: p.endDate == null ? null : moment.tz(p.endDate, moment.tz.guess()).format('YYYY-MM-DD'),
          endDateLocal: p.endDate == null ? null : moment.tz(p.endDate, moment.tz.guess()).format('YYYY-MM-DD'),
          branchId: p.branchId,
          code: p.code,
          projectRepositories: p.projectRepositoriesJSON == null ? [] : JSON.parse(p.projectRepositoriesJSON) as types.ProjectRepositoryParam[],
          workOrderNumbersJSON: p.workOrderNumbersJSON,
          defaultWorkOrderNumberId: p.defaultWorkOrderNumberId,
          workOrderNumbers: p.workOrderNumbersJSON == null ? [] : JSON.parse(p.workOrderNumbersJSON) as types.WorkOrderNumberParam[]
        }
      }) as Array<types.ProjectParamWithLocalDate>
    },
    convertProjectFromLocal(context,p:types.ProjectParamWithLocalDate): types.ProjectParam {
      const { rootState } = moduleActionContext(context, Project)
      return {
          projectId: p.projectId,
          clientId: p.clientId,
          tenantId: p.tenantId,
          name: p.name,
          nameKana: p.nameKana,
          isActive: p.isActive,
          startDate: p.startDateLocal == null ? null : moment.tz(p.startDateLocal, moment.tz.guess()).format('YYYY-MM-DD'),
          endDate: p.endDateLocal,
          branchId: p.branchId,
          code: p.code,
          projectRepositoriesJSON: JSON.stringify(p.projectRepositories),
          workOrderNumbersJSON: JSON.stringify(p.workOrderNumbers ?? []),
          defaultWorkOrderNumberId: p.defaultWorkOrderNumberId
        }
    },
    async getGithubOrgs(context): Promise<{ login: string; id: number; node_id: string; url: string; repos_url: string; events_url: string; hooks_url: string; issues_url: string; members_url: string; public_members_url: string; avatar_url: string; description: string | null; }[]> {
      const { dispatch, state, commit } = moduleActionContext(context, Project)
      var publics = await dispatch.getPublicGithubOrgs();
      var privates = await dispatch.getPrivateGithubOrgs();
      var all = publics.concat(privates);
      if (state.githubusername) {
        const hasPersonal = all.some(org => org.login === state.githubusername)
        if (!hasPersonal) {
          all.unshift({ login: state.githubusername, id: 0, node_id: '', url: '', repos_url: '', events_url: '', hooks_url: '', issues_url: '', members_url: '', public_members_url: '', avatar_url: '', description: null } as any)
        }
      }
      commit.SET_VALUE({name: 'orgs', value: all })
      return all
    },
    async getPrivateGithubOrgs(context): Promise<{ login: string; id: number; node_id: string; url: string; repos_url: string; events_url: string; hooks_url: string; issues_url: string; members_url: string; public_members_url: string; avatar_url: string; description: string | null; }[]> {
      const { rootState, state } = moduleActionContext(context, Project)
      type method = "GET /user/orgs"
      type Response = Endpoints[method]["response"];
      type Parameters = Endpoints[method]["parameters"];
      let param:Parameters = {per_page: 100}

      let token = rootState.Login.userInfo.githubUserToken
      const octokit = new Octokit({auth:token});
      const response: Response = await octokit.request("GET /user/orgs", param);

      return response.data
    },
    async getPublicGithubOrgs(context): Promise<{ login: string; id: number; node_id: string; url: string; repos_url: string; events_url: string; hooks_url: string; issues_url: string; members_url: string; public_members_url: string; avatar_url: string; description: string | null; }[]> {
      const { rootState, state } = moduleActionContext(context, Project)
      type method = "GET /users/{username}/orgs"
      type Response = Endpoints[method]["response"];
      type Parameters = Endpoints[method]["parameters"];
      let param:Parameters = {username: state.githubusername ?? '' ,per_page: 100}

      let token = rootState.Login.userInfo.githubUserToken
      const octokit = new Octokit({auth:token});
      const response: Response = await octokit.request("GET /users/{username}/orgs", param);
      return response.data
    },
    async getGithubUser(context) {
      const { rootState, commit } = moduleActionContext(context, Project)
      type method = "GET /user"
      type Response = Endpoints[method]["response"];
      type Parameters = Endpoints[method]["parameters"];
      let param:Parameters = {}

      let token = rootState.Login.userInfo.githubUserToken
      const octokit = new Octokit({auth:token});
      const response: Response = await octokit.request("GET /user", param)
      commit.SET_VALUE({name:'githubusername', value: response?.data?.login})
    },
    async getGithubOrgRepositories(context, org_login) : Promise<Endpoints["GET /orgs/{org}/repos"]["response"]["data"]> {
      const { dispatch, rootState, commit } = moduleActionContext(context, Project)
      let info = await dispatch.getGithubOrgInfo(org_login)
      let totalRepos = info.owned_private_repos ?? 0 + info.public_repos
      let pages = Math.floor(totalRepos / 100) + ((totalRepos % 100) > 0 ? 1 : 0)
      var repos: any = []
      type Response = Endpoints["GET /orgs/{org}/repos"]["response"];
      type Parameters = Endpoints["GET /orgs/{org}/repos"]["parameters"];
      let token = rootState.Login.userInfo.githubUserToken
      const octokit = new Octokit({auth:token})

      for(var i = 0; i < pages; i++) {
        let param:Parameters = {org:org_login, type:"all",per_page:100,page:i+1,sort:"full_name"}
        const response: Response = await octokit.request("GET /orgs/{org}/repos", param);
        response.data.forEach(obj => {
          repos.push(obj)
        })
      }
      return repos
    },
    async getGithubUserRepositories(context) : Promise<any[]> {
      const { rootState } = moduleActionContext(context, Project)
      var repos: any = []
      let token = rootState.Login.userInfo.githubUserToken
      const octokit = new Octokit({auth:token})

      let page = 1
      while (true) {
        const response = await octokit.request("GET /user/repos", {affiliation:"owner,collaborator,organization_member", per_page:100, page:page, sort:"full_name"})
        response.data.forEach((obj: any) => { repos.push(obj) })
        if (response.data.length < 100) break
        page++
      }
      return repos
    },
    async getGithubOrgInfo(context, org_login) : Promise<Endpoints["GET /orgs/{org}"]["response"]["data"]> {
      const { rootState, state } = moduleActionContext(context, Project)
      type method = "GET /orgs/{org}"
      type Response = Endpoints[method]["response"];
      type Parameters = Endpoints[method]["parameters"];
      let param:Parameters = {org:org_login}

      let token = rootState.Login.userInfo.githubUserToken
      const octokit = new Octokit({auth:token});
      const response: Response = await octokit.request("GET /orgs/{org}", param);
      return response.data
    }
  },
  namespaced: true
})

export default Project